import axios from "axios"
import { $Q } from "graditify-utils"
import { mediaQuery } from '../utils/media-query'
import { createSlider } from "./slider-component"
import { InstafeedItem } from "./instafeed-item"
import { createInterception } from "../utils/script-defer"
import { dataToggle } from "../utils/toggle-dataset"

class Instafeed extends HTMLElement {
  constructor() {
    super()
    this.token = this.validateAttribute(this.getAttribute('token'))
    this.logoSrc = this.validateAttribute(this.getAttribute('logo-src'))
    this.logoAlt = this.validateAttribute(this.getAttribute('logo-alt'))
  }

  async connectedCallback() {
    createInterception(this, () => {
      mediaQuery('(max-width: 767px)', () => {
        this.fillItems(true)
      })

      mediaQuery('(min-width: 768px)', () => {
        this.fillItems()
      })

      this.closeModal()
    })
  }

  /**
   * Validate if there are something in attribute
   * @param {string} attr - Attribute
   * @returns {string || null}
   */
  validateAttribute = (attr) => !attr || !attr.length ? null : attr

  /**
   * Request to instagram
   * @returns {object} data
   */
  async getInstaData() {
    if (!this.token) return
    const url = `https://graph.instagram.com/me/media?fields=caption,id,media_type,media_url,permalink,thumbnail_url,timestamp,username&access_token=${this.token}&limit=9`

    try {
      const data = await axios(url)
      return data.data
    } catch (error) {
      console.error({ error })
    }
  }

  /**
   * Get instagram data
   * Iterate to each post detail of instagram
   * Wrap item with div or swiper-slider depend of parameter slider
   * Insert items
   * If parameter slider if true initialize Swiper
   * @param {boolean} slider - If items are swiper-slide or div and init slider or not
   * @returns null - stop called
   */
  fillItems = async (slider = false) => {
    let wrapper = $Q('.js-insta-grid', this)
    if (slider) wrapper = $Q('swiper-container', this)
    if (!wrapper) return

    const { data } = await this.getInstaData()
    if (!data.length) return

    this.fillTitle(data[0].username)

    const items = data.map((details, i) => {
      const div = document.createElement(`${slider ? 'swiper-slide' : 'div'}`)

      div.classList.add('instafeed__item')
      details.logoSrc = this.logoSrc
      details.logoAlt = this.logoAlt
      div.append(new InstafeedItem({ ...details, index: i }))

      return div
    });

    wrapper.append(...items)
    if (slider) createSlider(wrapper)
    this.removeLoader()
  }

  /**
   * Inset username like section title
   * @param {string} username - Insta username and section title
   * @returns null - stop called
   */
  fillTitle = (username) => {
    const titleContainer = $Q('.js-instafeed-title')

    if (!titleContainer) return
    titleContainer.innerHTML = `@${username}`
  }

  removeLoader() {
    if (this.classList.contains('js-loader-active')) {
      this.classList.remove('loader-active')
      this.classList.remove('js-loader-active')
      const loader = $Q('#loading', this)

      if (loader) loader.remove()
    }
  }

  closeModal() {
    const modalContainer = $Q('#js-insta-modal')
    const closeModal = $Q('#js-insta-modal-close')
    if (!modalContainer || !closeModal) return


    closeModal.addEventListener('click', () => {
      dataToggle(modalContainer, true, null, true)
    })
  }
}

window.customElements.define('insta-feed', Instafeed)
